// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__VTn5F","column":"Footer_column__CzF99","connect":"Footer_connect__73IKb","socials":"Footer_socials__1huIS","yellow":"Footer_yellow__JYTu8"};